const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';

/** The backend shows only the sign-in methods enabled for this deployment. */
export default function SignInOptionsLink() {
  return (
    <a href={`${API_BASE_URL}/login.html`} className="signin-options-link">
      More sign-in options
    </a>
  );
}
